import removeAccents from './removeAccents';

export type TMenuSearchOption = { key: string; label: string; groupLabel: string };

// Extra search terms for some destinations, keyed by route. They only help to find the option:
// names and entities stay the same.
const MENU_SEARCH_ALIASES: Record<string, string[]> = {
  '/supply_orders': ['compras'],
  '/providers/internal': ['empleados'],
};

// Ignores case, accents and extra spaces.
export const normalizeMenuSearch = (value: string) => removeAccents(value)
  .toLocaleLowerCase()
  .trim()
  .replace(/\s+/g, ' ');

// Options whose name contains every word of the query, or with an alias equal to it.
// Exact names go first, then aliases, then names starting with the query; ties keep the menu order.
const searchMenuOptions = (query: string, options: TMenuSearchOption[]): TMenuSearchOption[] => {
  const needle = normalizeMenuSearch(query);
  if (!needle) return [];
  const words = needle.split(' ');
  const seen = new Set<string>();

  return options
    .filter(({ key }) => !seen.has(key) && seen.add(key))
    .map((option, order) => {
      const label = normalizeMenuSearch(option.label);
      const aliasMatch = (MENU_SEARCH_ALIASES[option.key] ?? []).some((alias) => normalizeMenuSearch(alias) === needle);
      const nameMatch = words.every((word) => label.includes(word));
      let score = 3;
      if (label === needle) score = 0;
      else if (aliasMatch) score = 1;
      else if (label.startsWith(needle)) score = 2;
      return {
        option, order, score, match: nameMatch || aliasMatch,
      };
    })
    .filter(({ match }) => match)
    .sort((a, b) => a.score - b.score || a.order - b.order)
    .map(({ option }) => option);
};

export default searchMenuOptions;
